import * as Sentry from '@sentry/react';

// Chances are that a job's payable or receivable is not yet ready. In thi case, the API will
// return a 404. This is to be expected and the error should be addressed in the UI.
export function ignorePayableOrReceivable404Rule(event: Sentry.ErrorEvent) {
  const is404ErrorReponse = event.contexts?.response?.status_code === 404;
  const isGETRequest = event.request?.method === 'GET';

  const requestUrl = event.request?.url ?? '';
  const regexp = /v1\/companies\/(\w|-){36}\/jobs\/(\w|-){36}\/(payable|receivable)$/;
  const isFetchingJobPayableOrReceivable = regexp.test(requestUrl);

  return is404ErrorReponse && isGETRequest && isFetchingJobPayableOrReceivable;
}
